;(function () {
  angular
    .module('contrast.notifications.settings.org')
    .factory(
      'NotificationOrganizationSettingsService',
      NotificationOrganizationSettingsService
    )

  function NotificationOrganizationSettingsService(
    $q,
    $translate,
    permissions,
    ErrorService,
    logger,
    notificationApiConfig,
    NOTIFICATION_TYPE,
    NOTIFICATION_CHANNELS,
    NOTIFICATION_TYPE_OPTIONS
  ) {
    'ngInject'

    var channelTypeMap = {
      db: NOTIFICATION_CHANNELS.DATABASE,
      email: NOTIFICATION_CHANNELS.EMAIL,
      webhook: NOTIFICATION_CHANNELS.WEBHOOK
    }

    var translGlobal = {
      title_all_attacks: $translate.instant('title_all_attacks')
    }

    var defaultTriggerObj = {
      value: NOTIFICATION_TYPE_OPTIONS.ALL,
      name: translGlobal.title_all_attacks
    }

    var service = {
      // model
      mail_enabled: true,
      settings: initSettings(),

      // api
      init: init,
      loadOrganizationSettings: loadOrganizationSettings,
      isMailEnabled: isMailEnabled,
      getDefaultTriggerObj: getDefaultTriggerObj,
      showOptions: showOptions,
      updateTypeChannels: updateTypeChannels,
      webhookChanged: webhookChanged,
      updateChannel: updateChannel,
      updateActivitySummary: updateActivitySummary,
      setSelectedWebhook: setSelectedWebhook,
      getSelectedWebhook: getSelectedWebhook,
      updateTrigger: updateTrigger,
      updateNotifyOnChange: updateNotifyOnChange,
      cleanTrigger: cleanTrigger,
      reloadShowOptions: reloadShowOptions
    }

    return service

    function init(vulnsOptions) {
      clearSelectedWebhook()

      return loadOrganizationSettings(vulnsOptions)
    }

    function initSettings() {
      var defaultSettingsObj = {
        show_options: false,
        status: [],
        db: {
          channelKey: 'db',
          enabled: false,
          disabled: false,
          updating: false
        },
        email: {
          channelKey: 'email',
          enabled: false,
          disabled: false,
          updating: false
        },
        webhook: {
          channelKey: 'webhook',
          enabled: false,
          disabled: true,
          updating: false
        }
      }

      /**
       * Notify property is meant to be used for triggers
       * VULNERABILITY_CHANGESTATUS_CLOSED and
       * VULNERABILITY_CHANGESTATUS_OPEN, which are only
       * enabled by a checkbox. When a row in the settings
       * is added for these triggers, consider moving this
       * notify property to a trigger object (see object in
       * line 70)
       */
      var settings = {
        selected_webhook: false,
        activity_summary: { updating: false, enabled: false },
        custom: false,
        notify: { update: false, enabled: false }
      }

      var val, valLC
      Object.keys(NOTIFICATION_TYPE).forEach(function (key) {
        val = NOTIFICATION_TYPE[key]
        valLC = val.toLowerCase()
        settings[valLC] = angular.copy(defaultSettingsObj)
        settings[valLC].type = val
      })

      return settings
    }

    function loadOrganizationSettings(vulnsOptions) {
      return notificationApiConfig
        .getOrganizationSettings()
        .then(function (response) {
          updateSettings(response, vulnsOptions)
        })
        .catch(ErrorService.processError)
    }

    function isMailEnabled() {
      return service.mail_enabled
    }

    function getDefaultTriggerObj() {
      return angular.copy(defaultTriggerObj)
    }

    /**
     * @desc Update settings object per object passed in 1st arg
     * @param data
     */
    function updateSettings(response, vulnsOptions) {
      var data = response.data

      service.mail_enabled = data.mail_enabled
      service.settings.custom = data.settings.custom
      if (service.mail_enabled) {
        service.settings.activity_summary.enabled =
          data.settings.activity_summary
      }

      _resetVulnerabilityView()

      data.settings.triggers.forEach(function (x) {
        updateTriggerView(x, vulnsOptions)
      })
    }

    function _resetVulnerabilityView() {
      service.settings['new_vulnerability'].vulns_options = []
      service.settings['new_vulnerability'].db.enabled = false
      service.settings['new_vulnerability'].email.enabled = false
      service.settings['new_vulnerability'].webhook.enabled = false
    }

    function _determineIfTriggerChannelIsEnabled(webhooks) {
      var selected = getSelectedWebhook()

      if (selected) {
        var webhook
        for (var i = 0, len = webhooks.length; i < len; i++) {
          webhook = webhooks[i]

          if (selected.value === webhook.id) {
            return true
          }
        }
      }
      return false
    }

    function updateTriggerView(trigger, vulnsOptions) {
      // Get the object in this service that we will update from the server response data
      var triggerView =
        service.settings[trigger.notification_type.toLowerCase()]
      if (!triggerView) {
        return
      }

      // trigger channels: DATABASE|EMAIL|WEBHOOK
      var hasChannelsEnabled = false
      trigger.channels.forEach(function (channel) {
        hasChannelsEnabled = hasChannelsEnabled || channel.enabled

        var name = channel.channel
        var channelEnabled = channel.enabled ? true : false
        if (name == NOTIFICATION_CHANNELS.DATABASE) {
          triggerView.db.enabled = triggerView.db.enabled || channelEnabled
        } else if (name == NOTIFICATION_CHANNELS.EMAIL) {
          triggerView.email.enabled =
            triggerView.email.enabled ||
            (channelEnabled && service.mail_enabled)
        } else if (name == NOTIFICATION_CHANNELS.WEBHOOK) {
          triggerView.webhook.webhooks = channel.webhooks.slice(0)
          triggerView.webhook.enabled =
            triggerView.webhook.enabled ||
            _determineIfTriggerChannelIsEnabled(triggerView.webhook.webhooks)
        }
      })

      switch (trigger.notification_type) {
        case NOTIFICATION_TYPE.NEW_ATTACK:
          if (trigger.all_attack_status) {
            triggerView.status = [service.getDefaultTriggerObj()]
          } else if (trigger.attack_status) {
            triggerView.status = trigger.attack_status
          }
          break
        case NOTIFICATION_TYPE.NEW_VULNERABILITY:
          if (trigger.all_rule_severities && trigger.all_server_environments) {
            triggerView.vulns_options = [service.getDefaultTriggerObj()]
          } else {
            if (trigger.rule_severities) {
              trigger.rule_severities.forEach(function (severity) {
                var object = _.find(vulnsOptions, function (option) {
                  return option.value === severity
                })
                if (object) {
                  triggerView.vulns_options.push(object)
                }
              })
            }
            if (trigger.server_environments) {
              trigger.server_environments.forEach(function (environment) {
                var object = _.find(vulnsOptions, function (option) {
                  return option.value === environment
                })
                if (object) {
                  triggerView.vulns_options.push(object)
                }
              })
            }
          }
          break
        case NOTIFICATION_TYPE.NEW_ASSET:
          if (trigger.all_asset_types) {
            triggerView.assets = [service.getDefaultTriggerObj()]
          } else if (trigger.asset_types) {
            triggerView.assets = trigger.asset_types
          }
          break
        case NOTIFICATION_TYPE.VULNERABILITY_CHANGESTATUS_OPEN:
        case NOTIFICATION_TYPE.VULNERABILITY_CHANGESTATUS_CLOSED:
          service.settings.notify.enabled = trigger.notify_on_change
          break
        default:
        // do nothing
      }

      triggerView.show_options = service.showOptions(triggerView)
    }

    function reloadShowOptions(triggerView) {
      triggerView.webhook.enabled = _determineIfTriggerChannelIsEnabled(
        triggerView.webhook.webhooks
      )
      triggerView.show_options = service.showOptions(triggerView)
    }

    function showOptions(trigger) {
      return (
        trigger.db.enabled === true ||
        (trigger.email.enabled === true && service.mail_enabled) ||
        trigger.webhook.enabled === true
      )
    }

    function updateTypeChannels(params, notificationType) {
      var promises = [
        notificationApiConfig.updateOrganizationNotificationChannel(
          notificationType,
          NOTIFICATION_CHANNELS.DATABASE,
          params.db
        ),
        notificationApiConfig.updateOrganizationNotificationChannel(
          notificationType,
          NOTIFICATION_CHANNELS.EMAIL,
          params.email
        )
      ]

      if (params.webhook.webhook_id) {
        promises.push(
          notificationApiConfig.updateOrganizationNotificationChannel(
            notificationType,
            NOTIFICATION_CHANNELS.WEBHOOK,
            params.webhook
          )
        )
      }

      return $q.all(promises).catch(ErrorService.processError)
    }

    function setSelectedWebhook(webhookObj) {
      service.settings.expiring_licenses.webhook.disabled = false
      service.settings.selected_webhook = webhookObj
    }

    function clearSelectedWebhook() {
      service.settings.selected_webhook = false
    }

    function getSelectedWebhook() {
      return service.settings.selected_webhook
    }

    // The currently selected webhook has changed, either programatically or via user interaction
    // We need to update the UI to display this webhook's state
    function webhookChanged(webhook) {
      setSelectedWebhook(webhook) // This should update the selection in the ui-select

      // The notification type will be enabled if this webhook is associated in the view
      function _determineIfEnabled(key) {
        var view = service.settings[key]
        var filtered = view.webhook.webhooks.filter(function (wh) {
          return wh.id === webhook.value
        })

        view.webhook.enabled = filtered.length > 0

        view.show_options = service.showOptions(view)
      }

      if (permissions.isRASPEnabled()) {
        _determineIfEnabled('new_attack')
      }

      ;[
        'new_vulnerability',
        'new_vulnerable_library',
        'new_sca_vulnerable_library',
        'server_offline',
        'new_vulnerability_comment',
        'new_asset',
        'expiring_licenses',
        'sast_failed_scan'
      ].forEach(_determineIfEnabled)
    }

    function updateChannel(typeKey, channelKey, vulnsOptions) {
      var entry = service.settings[typeKey]
      var status = entry[channelKey].enabled
      entry[channelKey].updating = true

      var triggerType = entry.type
      var data = { status: status }

      var channelType = channelTypeMap[channelKey]

      if (channelType == NOTIFICATION_CHANNELS.WEBHOOK) {
        data.webhook_id = getSelectedWebhook().value
      }

      var allItemIndex = _.findIndex(entry.vulns_options, function (item) {
        if (angular.isDefined(item.value)) {
          return item.value.toUpperCase() === NOTIFICATION_TYPE_OPTIONS.ALL
        } else {
          return false
        }
      })

      //Activate channel only if it fulfill one of these conditions:
      // * It is not new_vulnerability type
      // * if it has all option selected
      // * If it is changing from inactive to active
      if (
        typeKey !== 'new_vulnerability' ||
        allItemIndex !== -1 ||
        !entry.show_options ||
        _hasVulnerabilityOptionSelected(entry.vulns_options)
      ) {
        notificationApiConfig
          .updateOrganizationNotificationChannel(triggerType, channelType, data)
          .then(function () {
            entry.show_options = service.showOptions(entry)
          })
          .then(function () {
            service.loadOrganizationSettings(vulnsOptions)
          })
          .catch(function (response) {
            ErrorService.processError(response)
            entry[channelKey].enabled = !entry[channelKey].enabled
          })
          .finally(function () {
            entry[channelKey].updating = false
          })
      }
    }

    function _hasVulnerabilityOptionSelected(options) {
      return angular.isDefined(options) && options.length > 0
    }

    function updateActivitySummary() {
      service.settings.activity_summary.updating = true

      var data = { activity_summary: service.settings.activity_summary.enabled }

      return notificationApiConfig.updateOrganizationSettings(data).then(
        function () {
          service.settings.activity_summary.updating = false
        },
        function (response) {
          ErrorService.processError(response)
          service.settings.activity_summary.enabled =
            !service.settings.activity_summary.enabled
        }
      )
    }

    function updateTrigger(model, trigger, itemLength) {
      var data = {}
      var type = trigger.type
      if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
        if (
          model === NOTIFICATION_TYPE_OPTIONS.ALL ||
          itemLength == trigger.status.length
        ) {
          data.all_attack_status = true
        } else {
          data.attack_status = model
        }
      } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
        if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
          data.all_rule_severities = true
          data.all_server_environments = true
        } else if (model.group === 'SEVERITY') {
          data.rule_severity = model.value
        } else if (model.group === 'ENVIRONMENT') {
          data.server_environment = model.value
        }
      } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
        if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
          data.all_asset_types = true
        } else {
          data.asset_type = model
        }
      }

      var params = {
        db: { status: trigger.db.enabled },
        email: { status: trigger.email.enabled },
        webhook: {
          status: trigger.webhook.enabled,
          webhook_id: getSelectedWebhook().value
        }
      }

      if (data.all_rule_severities && data.all_server_environments) {
        service.updateTypeChannels(params, NOTIFICATION_TYPE.NEW_VULNERABILITY)
      }

      service.updateTypeChannels(params, type)

      notificationApiConfig.updateOrganizationNotificationType(type, data).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            if (data.all_attack_status) {
              trigger.status = [service.getDefaultTriggerObj()]
            } else {
              trigger.status = removeAllOption(trigger.status)
            }
          }

          if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            if (data.all_rule_severities && data.all_server_environments) {
              trigger.vulns_options = [service.getDefaultTriggerObj()]
            } else {
              var allOptionIndex = _.findIndex(
                trigger.vulns_options,
                function (x) {
                  return x.value === NOTIFICATION_TYPE_OPTIONS.ALL
                }
              )
              if (allOptionIndex != -1) {
                trigger.vulns_options = trigger.vulns_options
                  .slice(0, allOptionIndex)
                  .concat(
                    trigger.vulns_options.slice(
                      allOptionIndex + 1,
                      trigger.vulns_options.length
                    )
                  )
              }
            }
          }

          if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            if (data.all_asset_types) {
              trigger.assets = [service.getDefaultTriggerObj()]
            } else {
              trigger.assets = removeAllOption(trigger.assets)
            }
          }
        },
        function (response) {
          ErrorService.processError(response)

          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            service.settings.new_attack.status.splice(-1, 1)
          } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            service.settings.new_vulnerability.vulns_options.splice(-1, 1)
          } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            service.settings.new_asset.assets.splice(-1, 1)
          }
        }
      )
    }

    function updateNotifyOnChange() {
      notificationApiConfig
        .updateOrganizationNotifyOnUpdate({
          notify_on_change: service.settings.notify.enabled
        })
        .then(function () {
          service.settings.notify.updating = false
        })
    }

    function removeAllOption(array) {
      var index = _.indexOf(array, NOTIFICATION_TYPE_OPTIONS.ALL)
      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    function cleanTrigger(item, model, trigger) {
      var data = {}
      var type = trigger.type
      var autoSelectAll = false
      if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
        if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
          data.all_attack_status = false
        } else {
          data.attack_status = model
        }
        if (service.settings.new_attack.status.length == 0) {
          autoSelectAll = true
        }
      } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
        if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
          data.all_rule_severities = false
          data.all_server_environments = false
        } else if (item.group === 'SEVERITY') {
          data.rule_severity = model.value
        } else if (item.group === 'ENVIRONMENT') {
          data.server_environment = model.value
        }
        if (service.settings.new_vulnerability.vulns_options.length == 0) {
          autoSelectAll = true
        }
      } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
        if (model === NOTIFICATION_TYPE_OPTIONS.ALL) {
          data.all_asset_types = false
        } else {
          data.asset_type = model
        }
        if (service.settings.new_asset.assets.length == 0) {
          autoSelectAll = true
        }
      }

      notificationApiConfig.cleanOrganizationNotificationType(type, data).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          if (autoSelectAll) {
            updateTrigger(NOTIFICATION_TYPE_OPTIONS.ALL, trigger)
          }
        },
        function (response) {
          ErrorService.processError(response)

          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            service.settings.new_attack.status.push(model)
          } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            service.settings.new_vulnerability.vulns_options.push(model)
          } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            service.settings.new_asset.assets.push(model)
          }
        }
      )
    }
  }
})()
